import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { ICountryMySuffix } from 'src/app/shared/model/country-my-suffix.model';
import { ICurrency } from 'src/app/shared/model/currency.model';
import { ICurrencies } from 'src/app/shared/model/currencies.model';

type EntityResponseType = HttpResponse<ICurrencies>;
type EntityArrayResponseType = HttpResponse<ICurrencies[]>;
@Injectable({ providedIn: 'root' })
export class CurrencyService {
    private getResourceUrl = SERVER_API_URL + 'api/currencies';
    private resourceOpenUrl = SERVER_API_URL + 'api/open/currencies';
    private saveResourceUrl = SERVER_API_URL + 'api/save-currencies';

    private getSpotResourceUrl = SERVER_API_URL + 'api/spot-currencies';

    constructor(private http: HttpClient) {}
    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ICurrencies>(`${this.getResourceUrl}/${id}`, { observe: 'response' });
    }
    queryAll(): Observable<EntityArrayResponseType> {
        return this.http.get<ICurrencies[]>(this.getResourceUrl, { observe: 'response' });
    }
    spotQueryAll(): Observable<EntityArrayResponseType> {
        return this.http.get<ICurrencies[]>(this.getSpotResourceUrl, { observe: 'response' });
    }
    

    queryOpen(req?: any): Observable<EntityArrayResponseType> {
        return this.http.get<ICurrencies[]>(this.resourceOpenUrl, { observe: 'response' });
    }

    save(): Observable<any> {
        return this.http.get<any>(this.saveResourceUrl, { observe: 'response' });
    }
    query(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(SERVER_API_URL + 'api' + url, { params: options, observe: 'response' }).map((res: any) => this.convertDateArrayFromServer(res));
    }
    private convertDateArrayFromServer(res: any): any {
        return res.body;
    }
}
